import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const hasToken = !!Cookies.get('token');
  const isVerified = Cookies.get('is_verified') === 'true';

  // if (!hasToken) {
  //   return <Navigate to='/login' replace state={{ from: location }} />;
  // }

  // if (!location.pathname.startsWith('/exchange-profile') && !location.pathname.startsWith('/cx')) {
  //   return <Navigate to='/cx' replace />;
  // }

  // if (!isVerified && location.pathname !== '/verify') {
  //   return <Navigate to='/verify' replace />;
  // }

  // if (location.pathname == '/verify' && isVerified) {
  //   return <Navigate to='/contact-management' replace />
  // }

  if (!hasToken) {
    return <Navigate to='/login' replace state={{ from: location }} />;
  }

  if (!location.pathname.startsWith('/exchange-profile') && !location.pathname.startsWith('/cx')) {
    return <Navigate to='/cx' replace />;
  }

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default PrivateRoute;
